import React, { useState } from 'react';
import { motion } from 'framer-motion6';
import PropTypes from 'prop-types';
import { sizes } from 'style';
import styled from 'styled-components';
import _BenefitBadge from '../BenefitBadge';

const BenefitBadge = styled(motion(_BenefitBadge))``;

const Benefits = styled.div`
  max-width: 865px;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media ${sizes.tabletPortrait} {
    grid-template-columns: 1fr 1fr;
    justify-content: start;
  }

  @media ${sizes.tabletLandscape} {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }

  @media ${sizes.desktop} {
    justify-content: space-between;

    > div:last-child {
      margin-right: auto;
    }
  }
`;

const BenefitsGrid = ({ benefits, selectedBenefit, setSelectedBenefit }) => {
  const [openedBadgesIds, setOpenedBadgesIds] = useState([0]);
  const [isBadgeClicked, setIsBadgeClicked] = useState(false);

  const badgeVariants = {
    hide: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4 } }
  };

  return (
    <Benefits>
      {benefits.map((benefit) => (
        <div key={benefit.id}>
          <BenefitBadge
            key={benefit?.id}
            id={benefit?.id}
            name={benefit?.name}
            description={benefit?.description}
            icon={benefit?.icon}
            selectedBenefit={selectedBenefit}
            setSelectedBenefit={setSelectedBenefit}
            openedBadgesIds={openedBadgesIds}
            setOpenedBadgesIds={setOpenedBadgesIds}
            variants={badgeVariants}
            isBadgeClicked={isBadgeClicked}
            setIsBadgeClicked={setIsBadgeClicked}
          />
        </div>
      ))}
    </Benefits>
  );
};

BenefitsGrid.propTypes = {
  benefits: PropTypes.array.isRequired,
  selectedBenefit: PropTypes.number.isRequired,
  setSelectedBenefit: PropTypes.func.isRequired
};

export default BenefitsGrid;
